import React from 'react'
import { css } from '@emotion/css'
import { IconMaps } from '@ow/icons'
import {
  useSlateStatic,
  useSelected,
  useFocused,
  ReactEditor,
} from 'slate-react'
import { Transforms } from 'slate'

const Content = function ({ attributes, children, element }) {
  const editor = useSlateStatic()
  const path = ReactEditor.findPath(editor, element)

  const selected = useSelected()
  const focused = useFocused()
  const getThumbnail = (url) => {
    if (url.indexOf('ow-prod.oss-') > -1 || url.indexOf('ow-prod-cdn') > -1) {
      const position = url.indexOf('?Expires=')
      return `${
        position === -1 ? url : url.slice(0, position)
      }?x-oss-process=image/resize,h_270,m_lfit`
    }
    return url
  }
  return (
    <div {...attributes}>
      {children}
      <div
        contentEditable={false}
        className={css`
          position: relative;
        `}
      >
        <img
          src={getThumbnail(element.url)}
          alt=""
          className={css`
            display: block;
            max-width: 100%;
            max-height: 20em;
            box-shadow: ${selected && focused ? '0 0 0 3px #B4D5FF' : 'none'};
          `}
        />
        <br />
        <div
          onClick={() => Transforms.removeNodes(editor, { at: path })}
          className={css`
            display: ${selected && focused ? 'inline' : 'none'};
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.65);
            cursor: pointer;
            padding: 8px;
          `}
        >
          <IconMaps type="editorDelete" width={16} height={16} size={16} />
        </div>
      </div>
    </div>
  )
}
export default Content
